import PersonalDetails from '@/views/PersonalDetails/index.vue'

const PersonalDetailsRouter = {
  path: '/personal-details',
  name: 'PersonalDetails',
  component: PersonalDetails,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default PersonalDetailsRouter
